import request from '@/router/axios';

/**
 * 获取列表
 * @param {页数} page
 * @param {每页条数} limit
 * @param {查询参数} params
 */
export const getExpList = (page, limit, params) => {
    return request('/api/exp/expcourse2case/query', {
        method: 'get',
        params: {
            ...params,
            page,
            limit,
        }
    })
}